import { createContext } from 'react';

import { DisplaySymbol } from '@core';

export type Parameter = {
    id: string;
    label: string;
    unit: string;
    min: number;
    max: number;
    displaySymbol: DisplaySymbol;
};

export type Tare = Record<Parameter['id'], number[]>;

export const LiveAnalysisTableContext = createContext<{
    data: Tare[];
    parameters: Parameter[];
    sum: Tare;
    isSetup: boolean;
}>({
    data: [],
    parameters: [],
    sum: {},
    isSetup: false,
});
